export const lang =
    [
        {
            "field1": "",
            "ID": "1",
            "Key": "登录提示",
            "zh-CN": "参与庆典活动之前，请先完成登录！",
            "备注": "",
            "字节限制": "",
            "en": "Be sure to log in before joining the Anniversary event!",
            "ar": "احرص على تسجيل الدخول قبل الانضمام إلى فعالية الذكرى السنوية!",
            "fr": "N'oubliez pas de vous connecter avant de participer à l'événement Anniversaire !",
            "de": "Stelle sicher, dass du angemeldet bist, bevor du am Jubiläumsevent teilnimmst!",
            "id": "Pastikan untuk login sebelum bergabung di acara Hari Jadi!",
            "ja": "祭典に参加する前に、ログインしてください！",
            "ko": "주년 이벤트에 참여하기 전에 로그인하세요!",
            "pt": "Certifique-se de fazer login antes de participar do evento de Aniversário!",
            "ru": "Непременно войдите в аккаунт, прежде чем присоединяться к юбилейному событию!",
            "es": "¡Asegúrate de iniciar sesión antes de unirte al evento de aniversario!",
            "th": "อย่าลืมล็อกอินก่อนเข้าร่วมอีเวนต์ฉลองครบรอบนะ!",
            "tr": "Yıl Dönümü etkinliğine katılmadan önce giriş yapmayı unutma!",
            "vi": "Đừng quên đăng nhập trước khi tham gia sự kiện kỷ niệm đấy nhé!",
            "it": "Assicurati di effettuare l'accesso prima di partecipare all'evento dell'Anniversario!",
            "zh-TW": "參與慶典活動之前，請先完成登錄！"
        },
        {
            "field1": "",
            "ID": "2",
            "Key": "登录1",
            "zh-CN": "使用Facebook登录",
            "备注": "",
            "字节限制": "",
            "en": "Facebook Sign-in",
            "ar": "تسجيل الدخول باستخدام Facebook",
            "fr": "Connexion à Facebook",
            "de": "Anmeldung (Facebook)",
            "id": "Masuk Facebook",
            "ja": "Facebookでログインする",
            "ko": "페이스북으로 로그인",
            "pt": "Conectar com Facebook",
            "ru": "Вход через Facebook",
            "es": "Inicio de sesión en Facebook",
            "th": "ลงชื่อเข้าใช้ Facebook",
            "tr": "Facebook Girişi",
            "vi": "Đăng nhập qua Facebook",
            "it": "Accedi con Facebook",
            "zh-TW": "使用Facebook登錄"
        },
        {
            "field1": "",
            "ID": "3",
            "Key": "登录2",
            "zh-CN": "使用Twitter登录",
            "备注": "",
            "字节限制": "",
            "en": "Twitter Sign-in",
            "ar": "تسجيل الدخول باستخدام Twitter",
            "fr": "Connexion à Twitter",
            "de": "Anmeldung (Twitter)",
            "id": "Masuk Twitter",
            "ja": "Twitterでログインする",
            "ko": "트위터로 로그인",
            "pt": "Conectar com Twitter",
            "ru": "Вход через Twitter",
            "es": "Inicio de sesión en Twitter",
            "th": "ลงชื่อเข้าใช้ Twitter",
            "tr": "Twitter Girişi",
            "vi": "Đăng nhập qua Twitter",
            "it": "Accedi con Twitter",
            "zh-TW": "使用Twitter登錄"
        },
        {
            "field1": "",
            "ID": "4",
            "Key": "登录3",
            "zh-CN": "使用Line登录",
            "备注": "",
            "字节限制": "",
            "en": "Line Sign-in",
            "ar": "تسجيل الدخول باستخدام Line",
            "fr": "Connexion à Line",
            "de": "Anmeldung (Line)",
            "id": "Masuk Line",
            "ja": "Lineでログインする",
            "ko": "라인으로 로그인",
            "pt": "Conectar com Line",
            "ru": "Вход через Line",
            "es": "Inicio de sesión en Line",
            "th": "ลงชื่อเข้าใช้ Line",
            "tr": "Line Girişi",
            "vi": "Đăng nhập qua Line",
            "it": "Accedi con Line",
            "zh-TW": "使用Line登錄"
        },
        {
            "field1": "",
            "ID": "5",
            "Key": "Slogan",
            "zh-CN": "弓箭传说3周年庆典",
            "备注": "",
            "字节限制": "",
            "en": "Archero 3rd Anniversary",
            "ar": "الذكرى السنوية الثالثة للعبة Archero",
            "fr": "3e anniversaire d'Archero",
            "de": "03. Jubiläum von Archero",
            "id": "Hari Jadi Archero ke-3",
            "ja": "Archero3周年記念",
            "ko": "궁수의 전설 3주년",
            "pt": "3º Aniversário do Archero",
            "ru": "3-я годовщина Archero",
            "es": "Archero 3er Aniversario",
            "th": "Archero ฉลองครบรอบปีที่ 3",
            "tr": "Archero 3. Yıl Dönümü",
            "vi": "Lễ Kỷ Niệm Năm Thứ 3 của Archero",
            "it": "Terzo Anniversario di Archero",
            "zh-TW": "弓箭傳說3週年慶典"
        },
        {
            "field1": "",
            "ID": "6",
            "Key": "Description",
            "zh-CN": "完成拼图，共赴盛宴",
            "备注": "",
            "字节限制": "",
            "en": "Complete the puzzle to join the feast",
            "ar": "أكمل اللغز للانضمام إلى الاحتفال",
            "fr": "Terminez le puzzle pour participer au festin",
            "de": "Vervollständige das Puzzle, um am Fest teilzunehmen.",
            "id": "Selesaikan puzzle untuk bergabung dalam pesta ini",
            "ja": "パズルを完成させて、パーティーに参加しよう",
            "ko": "퍼즐을 완성하여 잔치에 참여하세요",
            "pt": "Complete o quebra-cabeças para participar da festa",
            "ru": "Соберите головоломку, чтобы присоединиться к празднеству",
            "es": "Completa el puzle para unirte al festín",
            "th": "ต่อพัซเซิลให้ครบเพื่อเข้าร่วมงานเลี้ยง",
            "tr": "Festivale katılmak için yapbozu tamamla",
            "vi": "Hoàn thành trò giải đố để tham gia đại tiệc",
            "it": "Completa il puzzle per partecipare alla festa",
            "zh-TW": "完成拼圖，共赴盛宴"
        },
        {
            "field1": "",
            "ID": "7",
            "Key": "拖动Tips",
            "zh-CN": "拖动拼图，把它放到正确的位置",
            "备注": "",
            "字节限制": "",
            "en": "Move puzzle pieces to their correct spot",
            "ar": "انقل قطع اللغز إلى مكانها الصحيح",
            "fr": "Déplacez les pièces du puzzle au bon endroit",
            "de": "Bewege die Puzzleteile an ihren richtigen Ort.",
            "id": "Pindahkan potongan puzzle ke tempat yang tepat",
            "ja": "パズルをドラッグして、正しい位置に置いてください",
            "ko": "퍼즐 조각을 올바른 위치로 이동하세요",
            "pt": "Mova as peças do quebra-cabeça para a posição correta",
            "ru": "Переместите части головоломки на их места",
            "es": "Mueve las piezas del puzle a su lugar correcto",
            "th": "ขยับชิ้นพัซเซิลไปให้ถูกตำแหน่ง",
            "tr": "Yapboz parçalarını doğru alanlara yerleştir",
            "vi": "Di chuyển các mảnh ghép câu đố đến vị trí đúng của chúng",
            "it": "Sposta i pezzi del puzzle nel posto giusto",
            "zh-TW": "拖動拼圖，把它放到正確的位置"
        },
        {
            "field1": "",
            "ID": "8",
            "Key": "提示Tips",
            "zh-CN": "位置错误，请重新选择",
            "备注": "",
            "字节限制": "",
            "en": "This is the wrong spot! Choose again",
            "ar": "هذا المكان الخطأ! اختر مجددًا",
            "fr": "Ce n'est pas le bon endroit ! Choisissez à nouveau",
            "de": "Das ist der falsche Ort! Wähle erneut!",
            "id": "Tempat ini salah! Pilih lagi",
            "ja": "位置が違います。もう一度選択してください",
            "ko": "잘못된 위치입니다! 다시 선택하세요.",
            "pt": "Posição errada! Escolha novamente",
            "ru": "Это не то место! Выберите еще раз",
            "es": "¡Lugar incorrecto! Vuelve a elegir",
            "th": "ผิดตำแหน่ง! เลือกอีกครั้ง",
            "tr": "Bu alan doğru değil! Yeniden seç",
            "vi": "Sai vị trí! Hãy chọn lại",
            "it": "Questo è il posto sbagliato! Scegli di nuovo",
            "zh-TW": "位置錯誤，請重新選擇"
        },
        {
            "field1": "",
            "ID": "8",
            "Key": "分享1",
            "zh-CN": "分享链接邀请好友",
            "备注": "",
            "字节限制": "",
            "en": "Share link to invite friends",
            "ar": "شارك الرابط لدعوة الأصدقاء",
            "fr": "Partagez le lien pour inviter des amis",
            "de": "Teile diesen Link, um Freunde einzuladen.",
            "id": "Bagikan tautan untuk mengundang teman",
            "ja": "リンクをシェアして友達を招待しましょう",
            "ko": "링크 공유로 친구 초대하기",
            "pt": "Compartilhe o link para convidar amigos",
            "ru": "Поделитесь ссылкой, чтобы пригласить друзей",
            "es": "Comparte el enlace para invitar a tus amigos",
            "th": "แชร์ลิงก์เพื่อเชิญเพื่อน",
            "tr": "Arkadaşlarını davet etmek için bağlantıyı paylaş",
            "vi": "Chia sẻ đường dẫn để mời thêm bạn bè",
            "it": "Condividi link per invitare gli amici",
            "zh-TW": "分享鏈接邀請好友"
        },
        {
            "field1": "",
            "ID": "9",
            "Key": "分享2",
            "zh-CN": "发布Facebook邀请好友",
            "备注": "",
            "字节限制": "",
            "en": "Post on Facebook to invite friends",
            "ar": "انشر على Facebook لدعوة الأصدقاء",
            "fr": "Publiez sur Facebook pour inviter des amis",
            "de": "Verfasse einen Beitrag auf Facebook, um Freunde einzuladen.",
            "id": "Postingkan di Facebook untuk mengundang teman",
            "ja": "Facebookで友達を招待する",
            "ko": "페이스북 게시로 친구 초대하기",
            "pt": "Publique no Facebook para convidar amigos",
            "ru": "Напишите в Facebook, чтобы пригласить друзей",
            "es": "Publica en Facebook para invitar a tus amigos",
            "th": "โพสต์บน Facebook เพื่อเชิญเพื่อน",
            "tr": "Arkadaşlarını davet etmek için Facebook'ta paylaş",
            "vi": "Đăng lên Facebook để mời thêm bạn bè",
            "it": "Pubblica su Facebook per invitare gli amici",
            "zh-TW": "發布Facebook邀請好友"
        },
        {
            "field1": "",
            "ID": "10",
            "Key": "分享3",
            "zh-CN": "发布Twitter邀请好友",
            "备注": "",
            "字节限制": "",
            "en": "Post on Twitter to invite friends",
            "ar": "انشر على Twitter لدعوة الأصدقاء",
            "fr": "Publiez sur Twitter pour inviter des amis",
            "de": "Verfasse einen Beitrag auf Twitter, um Freunde einzuladen.",
            "id": "Postingkan di Twitter untuk mengundang teman",
            "ja": "Twitterで友達を招待する",
            "ko": "트위터 게시로 친구 초대하기",
            "pt": "Publique no Twitter para convidar amigos",
            "ru": "Напишите в Twitter, чтобы пригласить друзей",
            "es": "Publica en Twitter para invitar a tus amigos",
            "th": "โพสต์บน Twitter เพื่อเชิญเพื่อน",
            "tr": "Arkadaşlarını davet etmek için Twitter'da paylaş",
            "vi": "Đăng lên Twitter để mời thêm bạn bè",
            "it": "Pubblica su Twitter per invitare gli amici",
            "zh-TW": "發布Twitter邀請好友"
        },
        {
            "field1": "",
            "ID": "11",
            "Key": "完成提示1",
            "zh-CN": "您的朋友帮您一起完成了拼图，快来领取奖励兑换码吧！",
            "备注": "",
            "字节限制": "",
            "en": "Your friends have helped you complete a puzzle! Claim your gift code now!",
            "ar": "ساعدك أصدقاؤك على إكمال اللغز! استلم رمز الهدية الآن!",
            "fr": "Vos amis vous ont aidé à terminer un puzzle ! Récupérez votre code cadeau dès maintenant !",
            "de": "Deine Freunde haben dir geholfen, ein Puzzle zu verfollständigen! Hol dir jetzt deinen Geschenkcode!",
            "id": "Temanmu telah membantu menyelesaikan puzzle! Klaim kode hadiahmu sekarang!",
            "ja": "友達が一緒にパズルを完成させてくれました。早く報酬コードを受け取りましょう！",
            "ko": "친구가 퍼즐을 완성하는 데 도움을 주었습니다! 지금 기프트코드를 획득하세요!",
            "pt": "Seus amigos ajudaram você a completar o quebra-cabeça! Pegue seu código de presente agora!",
            "ru": "Друзья помогли вам собрать головоломку! Получите свой подарочный код!",
            "es": "¡Tus amigos te han ayudado a completar un puzle! ¡Reclama tu código de regalo ahora!",
            "th": "เพื่อนของคุณช่วยต่อพัซเซิลให้แล้ว! เก็บรหัสของขวัญของคุณเลย!",
            "tr": "Arkadaşların yapbozu tamamlamana yardım etti! Hediye kodunu şimdi al!",
            "vi": "Bạn của bạn đã giúp hoàn thành trò giải đố! Hãy nhận mã quà tặng ngay bây giờ!",
            "it": "I tuoi amici ti hanno aiutato a completare un puzzle! Richiedi subito il tuo codice regalo!",
            "zh-TW": "您的朋友幫您一起完成了拼圖，快來領取獎勵兌換碼吧！"
        },
        {
            "field1": "",
            "ID": "12",
            "Key": "奖励兑换按钮",
            "zh-CN": "领取兑换码",
            "备注": "",
            "字节限制": "",
            "en": "Claim Gift Code",
            "ar": "استلم رمز الهدية",
            "fr": "Récupérer le code cadeau",
            "de": "Geschenkcode holen",
            "id": "Klaim Kode Hadiah",
            "ja": "コードを受取る",
            "ko": "기프트코드 획득",
            "pt": "Reivindicar Código de Presente",
            "ru": "Получить подарочный код",
            "es": "Reclamar código de regalo",
            "th": "เก็บรหัสของขวัญ",
            "tr": "Hediye Kodunu Al",
            "vi": "Nhận Mã Quà Tặng",
            "it": "Riscatta il tuo codice regalo",
            "zh-TW": "領取兌換碼"
        },
        {
            "field1": "",
            "ID": "13",
            "Key": "奖励说明",
            "zh-CN": "恭喜完成活动！感谢您和您的朋友{Name}共同完成拼图",
            "备注": "",
            "字节限制": "",
            "en": "You've completed the event! All thanks to you and your friend {Name} for completing the puzzle",
            "ar": "أكملت الفعالية! شكرًا لك ولصديقك {Name} على إكمال اللغز",
            "fr": "Vous avez terminé l'événement ! Merci à vous et à votre ami {Name} d'avoir terminé le puzzle",
            "de": "Dank deiner und {Name}s Hilfe beim Vervollständigen des Puzzles hast dieses Event nun abgeschlossen! Glückwunsch!",
            "id": "Kamu sudah menyelesaikan acara ini! Semuanya berkat kamu dan temanmu, {Name}, yang telah menyelesaikan puzzle",
            "ja": "イベント完了おめでとうございます！友達{Name}と共にパズルを完成させたことに感謝いたします",
            "ko": "이벤트를 완료했습니다! 친구 {Name}와(과) 함께 퍼즐을 완성해 주셔서 감사합니다",
            "pt": "Você concluiu o evento! Tudo graças a você e seu amigo {Name} por terminar o quebra-cabeça",
            "ru": "Вы прошли событие! А все потому, что вы и ваш друг {Name} собрали головоломку",
            "es": "¡Has completado el evento! Muchas gracias a ti y a tu amigo {Nombre} por completar el puzle",
            "th": "คุณเล่นอีเวนต์เสร็จสิ้นแล้ว! ทั้งหมดนี้ก็เพราะคุณกับ {Name} เพื่อนของคุณที่ต่อพัซเซิลจนเสร็จ",
            "tr": "Etkinliği tamamladın! Arkadaşın {Name} ile birlikte yapbozu tamamladınız",
            "vi": "Bạn đã hoàn thành sự kiện! Rất cảm ơn bạn và {Name} đã hoàn thành trò giải đố",
            "it": "Hai completato l'evento! Grazie a te e al tuo amico {Name} per aver completato il puzzle",
            "zh-TW": "恭喜完成活動！感謝您和您的朋友{Name}共同完成拼圖"
        },
        {
            "field1": "",
            "ID": "14",
            "Key": "奖励说明",
            "zh-CN": "您和您的朋友将会得到一份奖励兑换码！",
            "备注": "",
            "字节限制": "",
            "en": "You and your friend will obtain a gift code reward!",
            "ar": "ستحصل أنت وصديقك على مكافأة رمز الهدية!",
            "fr": "Vous et votre ami recevrez un code cadeau en récompense !",
            "de": "Du und dein Freund werden eine Geschenkcode-Belohnung erhalten!",
            "id": "Kamu dan temanmu akan memperoleh imbalan kode hadiah!",
            "ja": "あなたと友達は報酬コードを獲得します！",
            "ko": "당신과 친구는 기프트코드 보상을 받게됩니다!",
            "pt": "Você e seu amigo receberão uma recompensa de código de presente!",
            "ru": "Вы с другом получите в награду подарочный код!",
            "es": "¡Tú y tu amigo obtendréis una recompensa en forma de código de regalo!",
            "th": "คุณกับเพื่อจะได้รับรางวัลรหัสของขวัญ!",
            "tr": "Arkadaşın ve sen bir hediye kodu ödülü alacaksınız!",
            "vi": "Bạn và bạn của bạn sẽ nhận được một phần mã quà tặng!",
            "it": "Tu e il tuo amico riceverete un codice regalo in premio!",
            "zh-TW": "您和您的朋友將會得到一份獎勵兌換碼！"
        },
        {
            "field1": "",
            "ID": "15",
            "Key": "奖励说明",
            "zh-CN": "复制下方兑换码，您将得到：随机金色跟班*1，金币*50000，黑曜石宝箱钥匙*1，尊贵皮肤券*1",
            "备注": "",
            "字节限制": "",
            "en": "Copy the code below to get: Random Legendary Spirit*1, Coin*50000, Obsidian Chest Key *1, Premium Coupon*1",
            "ar": "انسخ الرمز أدناه للحصول على: روح أسطورية عشوائية *1، عملات *50000، مفتاح صندوق السبج *1، قسيمة متميزة *1",
            "fr": "Copiez le code ci-dessous pour obtenir : Esprit légendaire aléatoire*1, Pièce*50000, Clé de coffre en obsidienne*1, Coupon premium*1",
            "de": "Kopiere den unteren Code, um Folgendes zu erhalten: 1x Legendärer Geist, 50000 Münzen, 1 Obsidiantruhen-Schlüssel und 1 Premium-Coupon.",
            "id": "Salin kode di bawah untuk mendapatkan: Roh Legendaris Acak*1, Koin*50000, Kunci Peti Obsidian *1, Kupon Premium*1",
            "ja": "下のコードをコピーして、以下を獲得：ランダム金色スピリット*1、コイン*50000、黒曜石ボックスの鍵*1、プレミアムクーポン*1",
            "ko": "아래 코드를 복사하면 다음을 얻을 수 있습니다: 랜덤 레전드 펫*1, 코인*50000, 흑요석 상자 열쇠*1, 프리미엄 쿠폰*1",
            "pt": "Copie o código abaixo para obter: Espírito Lendário aleatório *1, Moeda *50000, Chave de Baú Obsidiano *1, Cupom Premium *1",
            "ru": "Скопируйте код в поле ниже и получите: случайный легендарный дух*1, монеты*50000, ключ от обсидианового сундука*1, премиальный купон*1",
            "es": "Copia el código de abajo para obtener: espíritu legendario aleatorio x1, monedas x50.000, llave de cofre de obsidiana x1, cupón premium x1",
            "th": "คัดลอกรหัสด้านล่างเพื่อรับ: ภูตในตำนานแบบสุ่ม*1, เหรียญ*50000, กุญแจหีบออบซิเดียน*1, คูปองพรีเมียม*1",
            "tr": "Almak için aşağıdaki kodu kopyala: Rastgele Efsanevi Ruh*1, Altın*50000, Obsidyan Sandık Anahtarı *1, Seçkin Kupon*1",
            "vi": "Hãy sao chép mã dưới đây để nhận: Vệ Linh Huyền Thoại Ngẫu Nhiên*1, Xu*50000, Chìa Khóa Rương Hắc Diệu Thạch*1, Phiếu Cao Cấp*1",
            "it": "Copia il codice qui sotto per ottenere: Spirito leggendario casuale*1, Moneta*50000, Chiave per Casse di ossidiana *1, Buono premium*1",
            "zh-TW": "複製下方兌換碼，您將得到：隨機金色跟班*1，金幣*50000，黑曜石寶箱鑰匙*1，尊貴皮膚券*1"
        },
        {
            "field1": "",
            "ID": "16",
            "Key": "兑换提示",
            "zh-CN": "点击下方网址去兑换界面兑换您的礼包码哦",
            "备注": "",
            "字节限制": "",
            "en": "Tap the link below to head to the Reward Page and claim your gift code!",
            "ar": "انقر فوق الرابط أدناه للانتقال إلى صفحة المكافآت واستلام رمز هديتك!",
            "fr": "Appuyez sur le lien ci-dessous pour accéder à la page de récompense et récupérer votre code cadeau !",
            "de": "Tippe auf den folgenden Link, um auf die Belohnungsseite zu gelangen und dir deinen Geschenkcode zu holen!",
            "id": "Ketuk tautan di bawah untuk menuju Halaman Imbalan dan mengeklaim kode hadiahmu!",
            "ja": "下のURLをタップして交換画面に行くとパックコードに交換できます",
            "ko": "아래 링크를 탭하여 보상 페이지로 이동하고 기프트코드를 교환하세요!",
            "pt": "Toque no link abaixo para ir à página de Recompensas e reivindicar seu código de presente!",
            "ru": "Коснитесь ссылки, чтобы перейти на страницу наград и получить подарочный код!",
            "es": "¡Toca el enlace de abajo para ir a la página de recompensas y reclamar tu código de regalo!",
            "th": "แตะลิงก์ด้านล่างเพื่อไปยังหน้ารางวัลและเก็บรหัสของขวัญของคุณ!",
            "tr": "Ödül Sayfasına gitmek için aşağıdaki linke dokun ve ödül kodunu al!",
            "vi": "Nhấp vào đường dẫn dưới đây để chuyển đến Trang Phần Thưởng và nhận mã quà tặng của bạn!",
            "it": "Tocca il link qui sotto per andare alla Pagina dei premi e richiedere il tuo codice regalo!",
            "zh-TW": "點擊下方網址去兌換界面兌換您的禮包碼哦"
        },
        {
            "field1": "",
            "ID": "17",
            "Key": "兑换按钮",
            "zh-CN": "去兑换",
            "备注": "",
            "字节限制": "",
            "en": "Exchange",
            "ar": "استبدال",
            "fr": "Échange",
            "de": "Einlösung",
            "id": "Tukarkan",
            "ja": "交換する",
            "ko": "교환",
            "pt": "Trocar",
            "ru": "Обмен",
            "es": "Intercambiar",
            "th": "แลกเปลี่ยน",
            "tr": "Takas",
            "vi": "Trao đổi",
            "it": "Scambia",
            "zh-TW": "去兌換"
        },
        {
            "field1": "",
            "ID": "18",
            "Key": "说明",
            "zh-CN": "如何参与庆典活动",
            "备注": "",
            "字节限制": "",
            "en": "How to Join Anniversary Event",
            "ar": "كيفية الانضمام إلى فعالية الذكرى السنوية",
            "fr": "Comment participer à un événement anniversaire",
            "de": "Wie man am Jubiläumsevent teilnimmt",
            "id": "Cara Bergabung di Acara Hari Jadi",
            "ja": "祭典イベント参加方法",
            "ko": "주년 이벤트 참여 방법",
            "pt": "Como participar do evento de Aniversário",
            "ru": "Как принять участие в юбилейном событии",
            "es": "Cómo participar en el evento del aniversario",
            "th": "วิธีเข้าร่วมอีเวนต์ฉลองครบรอบ",
            "tr": "Yıl Dönümü Etkinliğine Nasıl Katılınır",
            "vi": "Làm sao để tham dự Sự Kiện Kỷ Niệm",
            "it": "Come partecipare all'evento dell'Anniversario",
            "zh-TW": "如何參與慶典活動"
        },
        {
            "field1": "",
            "ID": "19",
            "Key": "说明",
            "zh-CN": "1.玩家完成登录后，完成8片拼图<p></p></p>2.邀请好友参与活动，完成其他8片拼图，组成完整图案。<p></p>3. 获得的礼包码仅可兑换一次，兑换截止日期为2022年8月31日。<p></p>4.HABBY保留该活动最终解释权。",
            "备注": "",
            "字节限制": "",
            "en": "1. Log in and complete 8 puzzle pieces.<p></p>2. Invite friends to join the event and complete the other 8 pieces to form a complete puzzle.<p></p>3. Obtained gift code can only be exchanged once. Radeem ends 31st August 2022.<p></p>4. HABBY reserves final interpretation rights for this event.",
            "ar": "1. سجّل الدخول وأكمل 8 من قطع اللغز<p></p> 2. ادعُ الأصدقاء للانضمام إلى الفعالية وإكمال القطع الثماني الأخرى لإكمال اللغز.<p></p>3. يمكنك الحصول على رمز الهدية فقط عن طريق الاستبدال مرة واحدة. ينتهي الاسترداد في 31 أغسطس 2022.<p></p>4. تحتفظ HABBY بحقوق الترجمة النهائية لهذه الفعالية.",
            "fr": "1. Connectez-vous et complétez 8 pièces de puzzle.<p></p>2. Invitez des amis à rejoindre l'événement et complétez les 8 autres pièces pour former un puzzle complet.<p></p>3. Le code cadeau obtenu ne peut être échangé qu'une seule fois. L'échange prend fin le 31 août 2022.<p></p>4. HABBY se réserve le droit d'interprétation final pour cet événement.",
            "de": "1. Anmelden und 8 Puzzleteile zusammenfügen.<p></p>2. Freunde zum Event einladen und die anderen 8 Puzzleteile zusammenfügen.<p></p>3. Der erhaltene Geschenkcode kann nur einmal eingelöst werden. Die Einlösefrist endet am 31. August 2022.<p></p>4. HABBY behält sich das endgültige Interpretationsrecht für dieses Event vor.",
            "id": "1. Login dan selesaikan 8 potongan puzzle.<p></p>2. Undang teman untuk bergabung di acara ini dan selesaikan 8 potongan lainnya untuk membentuk puzzle yang utuh.<p></p>3. Kode hadiah yang diperoleh hanya bisa ditukarkan satu kali. Penukaran berakhir pada 31 Agustus 2022.<p></p>4. HABBY berhak atas interpretasi akhir dari acara ini.",
            "ja": "1.ログイン後、8つのパズルを完成させる。<p></p>2.友達をイベントに招待し、ほかの8つのパズルを完成させ、完全な絵柄に組み合わせる。<p></p>3.獲得したパックコードは1度のみ交換できます。交換は2022年8月31日までです。<p></p>4.HABBYがこのイベントの最終釈明権を保留します。",
            "ko": "1. 로그인 후 8조각 퍼즐을 완성하세요.<p></p>2. 친구를 이벤트에 초대하고 나머지 8조각 퍼즐을 완성하여 완전한 퍼즐을 완성하세요.<p></p>3. 획득한 기프트코드는 1회만 사용할 수 있으며 보상 교환은 2022년8월 31일에 종료됩니다.<p></p>4. HABBY는 이 이벤트에 대한 최종 해석 권한을 보유합니다.",
            "pt": "1. Faça login e complete 8 peças do quebra-cabeça.<p></p>2. Convide amigos para participar do evento e completar as 8 peças para completar o quebra-cabeça.<p></p>3. O código de presente obtido só pode ser trocado uma vez. Resgate termina do dia 31 de agosto de 2022.<p></p>4. HABBY reserva direitos de interpretação final para o evento.",
            "ru": "1. Войдите в игру и сложите 8 частей головоломки.<p></p>2. Пригласите друзей принять участие в событии и поставьте на место еще 8 частей, чтобы собрать головоломку до конца.<p></p>3. Полученный подарочный код можно обменять только один раз. После 31 августа 2022 года обмен будет невозможен.<p></p>4. HABBY оставляет за собой право окончательной интерпретации этого события.",
            "es": "1. Inicia sesión y completa 8 piezas de puzle<p></p>2. Invita a tus amigos a unirse al evento y completa las otras 8 piezas para formar un puzle completo.<p></p>3. El código de regalo obtenido solo se puede canjear una vez. El periodo de canje finaliza el 31 de agosto de 2022.<p></p>4. HABBY se reserva el derecho de interpretación final de este evento.",
            "th": "1. ล็อกอินและต่อพัซเซิลให้ครบ 8 ชิ้น.<p></p>2. เชิญเพื่อนมาเข้าร่วมอีเวนต์และต่ออีก 8 ชิ้นให้พัซเซิลครบสมบูรณ์.<p></p>3. สามารถแลกเปลี่ยนรหัสของขวัญได้ครั้งเดียวเท่านั้น ซึ่งแลกรับจะสิ้นสุดในวันที่ 31 สิงหาคม 2022.<p></p>4. HABBY ขอสงวนสิทธิ์ในการตัดสินขั้นสุดท้ายสำหรับอีเวนต์นี้",
            "tr": "1. Giriş yap ve 8 yapboz parçasını yerleştir. <p></p>2. Arkadaşlarını davet et ve yapbozu tamamlamak için diğer 8 parçayı da yerleştir.<p></p>3. Alınan hediye kodu yalnızca bir defa kullanılabilir. Takas, 31 Ağustos 2022'de sona erer. <p></p>4. HABBY, etkinliğin tüm ayrıntılarını yorumlama hakkını saklı tutar.",
            "vi": "1. Đăng nhập và hoàn thành 8 mảnh ghép câu đố<p></p>2. Mời bạn bè tham gia sự kiện và hoàn thành thêm 8 mảnh ghép nữa để hoàn thành trò giải đố.<p></p>3. Mã quà tặng nhận được chỉ có thể được đổi một lần. Việc trao đổi sẽ kết thúc vào 30/08/2022.<p></p>4. HABBY là bên có quyền giải thích cuối cùng đối với sự kiện",
            "it": "1. Accedi e completa 8 pezzi del puzzle.<p></p>2. Invita gli amici a partecipare all'evento e completa gli altri 8 pezzi per formare un puzzle completo.<p></p>3. Il codice regalo ottenuto può essere scambiato una sola volta. Riscattalo entro il 31 agosto 2022.<p></p>4. HABBY si riserva i diritti di interpretazione finale per questo evento.",
            "zh-TW": "1.玩家完成登錄後，完成8片拼圖。<p></p>2.邀請好友參與活動，完成其他8片拼圖，組成完整圖案。<p></p>3. 獲得的禮包碼僅可兌換一次，兌換截止日期為2022年8月31日。<p></p>4.HABBY保留該活動最終解釋權。"
        },
        {
            "field1": "",
            "ID": "20",
            "Key": "结束提示",
            "zh-CN": "您来晚了！拼图已完成",
            "备注": "",
            "字节限制": "",
            "en": "You're too late! The puzzle has been completed",
            "ar": "لقد تأخرت كثيرًا! اكتمل اللغز",
            "fr": "Vous arrivez trop tard ! Le puzzle est terminé",
            "de": "Du bist zu spät! Das Puzzle wurde schon vervollständigt!",
            "id": "Kamu terlambat! Puzzle sudah diselesaikan",
            "ja": "遅かったですね！パズルは完成しました",
            "ko": "너무 늦었어요! 퍼즐이 완성되었습니다",
            "pt": "Tarde demais! O quebra-cabeça foi completado",
            "ru": "Вы опоздали! Эта головоломка уже собрана",
            "es": "¡Llegas demasiado tarde! El puzle se ha completado",
            "th": "คุณมาช้าเกินไป! พัซเซิลเสร็จสมบูรณ์แล้ว",
            "tr": "Çok geç kaldın! Yapboz çoktan tamamlandı!",
            "vi": "Muộn mất rồi! Trò giải đố đã được hoàn thành",
            "it": "Sei in ritardo! Il puzzle è stato completato",
            "zh-TW": "您來晚了！拼圖已完成"
        },
        {
            "field1": "",
            "ID": "21",
            "Key": "邀请弹窗",
            "zh-CN": "您的朋友{Name}邀请您参与Archero庆典活动，快帮他完成拼图吧！",
            "备注": "",
            "字节限制": "",
            "en": "Your friend {Name} has invited you to join Archero's Anniversary Event. Help your friend finish the puzzle!",
            "ar": "دعاك صديقك {Name} للانضمام إلى فعالية الذكرى السنوية للعبة Archero. ساعد صديقك على إكمال اللغز!",
            "fr": "Votre ami {Name} vous a invité à rejoindre l'événement anniversaire d'Archero. Aidez votre ami à terminer le puzzle !",
            "de": "Dein Freund {Name} hat dich eingeladen, an Archero's Jubiläumsevent teilzunehmen. Stehe deinem Freund bei, um ein Puzzle zu vervollständigen!",
            "id": "Temanmu, {Name}, mengundangmu untuk bergabung di Acara Hari Jadi Archero. Bantu temanmu menyelesaikan puzzle!",
            "ja": "友達{Name}がArchero祭典イベントに招待しています。早くパズルを完成させましょう！",
            "ko": "친구 {Name}이(가) 궁수의 전설의 주년 이벤트에 초대했습니다. 친구가 퍼즐을 완성하도록 도와주세요!",
            "pt": "Seu amigo {Name} convidou você para participar do evento de Aniversário do Archero. Ajude seu amigo a terminar o quebra-cabeça!",
            "ru": "Ваш друг {Name} приглашает вас принять участие в юбилейном событии Archero. Помогите другу собрать головоломку!",
            "es": "Tu amigo {Name} te ha invitado a unirte al evento de aniversario de Archero. ¡Ayuda a tu amigo a terminar el puzle!",
            "th": "{Name} เพื่อนของคุณได้เชิญคุณเข้าร่วมอีเวนต์ฉลองครบรอบของ Archero ไปช่วยเพื่อนของคุณต่อพัซเซิลให้เสร็จ!",
            "tr": "Arkadaşın {Name} seni Archero'nun Yıl Dönümü Etkinliğine davet ediyor. Arkadaşının yapbozu tamamlamasına yardım et!",
            "vi": "{Name} đã mời bạn tham dự Sự Kiện Kỷ Niệm của Archero. Hãy giúp bạn của bạn hoàn thành trò giải đố!",
            "it": "Il tuo amico {Name} ti ha invitato a partecipare all'evento dell'Anniversario di Archero. Aiuta il tuo amico a finire il puzzle!",
            "zh-TW": "您的朋友{Name}邀請您參與Archero慶典活動，快幫他完成拼圖吧！"
        },
        {
            "field1": "",
            "ID": "22",
            "Key": "邀请弹窗",
            "zh-CN": "一起完成拼图",
            "备注": "",
            "字节限制": "",
            "en": "Complete puzzle together",
            "ar": "أكملا اللغز معًا",
            "fr": "Terminez le puzzle ensemble",
            "de": "Puzzle gemeinsam vervollständigen",
            "id": "Selesaikan puzzle bersama-sama",
            "ja": "一緒にパズルを完成させる",
            "ko": "함께 퍼즐을 완성하세요",
            "pt": "Completem o quebra-cabeça juntos",
            "ru": "Соберите головоломку вместе",
            "es": "Completad el puzle juntos",
            "th": "ต่อพัซเซิลด้วยกัน",
            "tr": "Yapbozu birlikte tamamlayın",
            "vi": "Hãy hoàn thành trò giải đố cùng nhau",
            "it": "Completate il puzzle insieme",
            "zh-TW": "一起完成拼圖"
        },
        {
            "field1": "",
            "ID": "23",
            "Key": "邀请弹窗",
            "zh-CN": "不，我要创建新拼图",
            "备注": "",
            "字节限制": "",
            "en": "Start new puzzle",
            "ar": "ابدأ لغزًا جديدًا",
            "fr": "Commencer un nouveau puzzle",
            "de": "Neues Puzzle starten",
            "id": "Mulai puzzle baru",
            "ja": "いいえ、新しいパズルを作ります",
            "ko": "새로운 퍼즐 시작",
            "pt": "Começar novo quebra-cabeça",
            "ru": "Начать новую головоломку",
            "es": "Empezar un nuevo puzle",
            "th": "เริ่มพัซเซิลใหม่",
            "tr": "Yeni yapboza başla",
            "vi": "Bắt đầu trò giải đố mới",
            "it": "Inizia un nuovo puzzle",
            "zh-TW": "不，我要創建新拼圖"
        },
        {
            "field1": "",
            "ID": "24",
            "Key": "结束提示",
            "zh-CN": "真遗憾，您来晚了！{Name}的拼图已完成",
            "备注": "",
            "字节限制": "",
            "en": "Oh no, you're too late! {Name}'s puzzle has been completed",
            "ar": "أوه لا، لقد تأخرت كثيرًا! أكمل {Name} اللغز.",
            "fr": "Oh non, vous arrivez trop tard ! Le puzzle de {Name} est terminé",
            "de": "Oh nein, du kommst zu spät! {Name}s Puzzle wurde bereits vervollständigt.",
            "id": "Wah, kamu terlambat! Puzzle {Name} sudah diselesaikan",
            "ja": "残念、一足遅かった！{Name}のパズルは完成しています",
            "ko": "너무 늦었어요! {Name}님의 퍼즐이 완성되었습니다",
            "pt": "Ah, não, é tarde demais! O quebra-cabeça de {Name} já foi concluído",
            "ru": "О нет, вы опоздали! Головоломка вашего друга {Name} уже собрана",
            "es": "¡Oh no, llegas demasiado tarde! El puzle de {Name} ya se ha completado",
            "th": "ไม่นะ คุณมาช้าเกินไป! พัซเซิลของ {Name} ได้ต่อเสร็จแล้ว",
            "tr": "Olamaz, çok geç kaldın! {Name} yapbozu tamamladı",
            "vi": "Ôi không, muộn mất rồi! {Name} đã hoàn thành trò giải đố trước",
            "it": "Oh no, sei in ritardo! Il puzzle di {Name} è stato completato",
            "zh-TW": "真遺憾，您來晚了！ {Name}的拼圖已完成"
        },
        {
            "field1": "",
            "ID": "25",
            "Key": "结束提示",
            "zh-CN": "邀请其他朋友完成拼图",
            "备注": "",
            "字节限制": "",
            "en": "Invite other friends to finish the puzzle",
            "ar": "ادعُ أصدقاءك الآخرين لإكمال اللغز",
            "fr": "Invitez d'autres amis à terminer le puzzle",
            "de": "Lade andere Freunde ein, um das Puzzle zu vervollständigen.",
            "id": "Undang teman lain untuk menyelesaikan puzzle",
            "ja": "ほかの友達を招待しパズルを完成させる",
            "ko": "다른 친구를 초대하여 퍼즐을 완성하세요",
            "pt": "Convide outros amigos para terminar o quebra-cabeça",
            "ru": "Пригласите друзей, чтобы закончить головоломку",
            "es": "Invita a otros amigos a terminar el puzle",
            "th": "เชิญเพื่อนคนอื่นมาต่อพัซเซิลให้เสร็จ",
            "tr": "Yapbozu tamamlamak için diğer arkadaşlarını davet et",
            "vi": "Mời thêm bạn tham gia để hoàn thành trò giải đố",
            "it": "Invita altri amici a completare il puzzle",
            "zh-TW": "邀請其他朋友完成拼圖"
        },
        {
            "field1": "",
            "ID": "26",
            "Key": "结束提示",
            "zh-CN": "好吧，退出",
            "备注": "",
            "字节限制": "",
            "en": "Leave",
            "ar": "مغادرة",
            "fr": "Quitter",
            "de": "Verlassen",
            "id": "Keluar",
            "ja": "OK、終了する",
            "ko": "나가기",
            "pt": "Sair",
            "ru": "Уйти",
            "es": "Salir",
            "th": "ออก",
            "tr": "Ayrıl",
            "vi": "Thoát ra",
            "it": "Abbandona",
            "zh-TW": "好吧，退出"
        },
        {
            "field1": "",
            "ID": "27",
            "Key": "分享链接复制",
            "zh-CN": "分享链接已复制成功，快去分享吧",
            "备注": "",
            "字节限制": "",
            "en": "The link has been copied successfully, share it!",
            "ar": "تم نسخ الرابط بنجاح، قم بمشاركته!",
            "fr": "Le lien a été copié avec succès, partagez-le !",
            "de": "Der Link wurde erfolgreich kopiert, jetzt teilen!",
            "id": "Tautan berhasil disalin, bagikan!",
            "ja": "リンクがコピーされました。共有しましょう！",
            "ko": "공유 링크가 성공적으로 복사되었습니다. 이동하여 공유하십시오.",
            "pt": "O link foi copiado com sucesso, compartilhe ele!",
            "ru": "Ссылка скопирована; поделитесь ею!",
            "es": "Se ha copiado el enlace correctamente, ¡compártelo!",
            "th": "คัดลอกลิงก์สำเร็ตแล้ว แชร์เลย!",
            "tr": "Đã sao chép liên kết thành công, hãy mau chia sẻ nó!",
            "vi": "Il link è stato copiato con successo; condividilo!",
            "it": "Bağlantı başarıyla kopyalandı, paylaşabilirsin!",
            "zh-TW": "分享鏈接已復製成功，快去分享吧"
        },
        {
            "field1": "",
            "ID": "28",
            "Key": "礼包码复制",
            "zh-CN": "礼包码已复制成功，快去兑换大奖！",
            "备注": "",
            "字节限制": "",
            "en": "The Reward Code has been copied successfully, go and redeem it!",
            "ar": "تم نسخ رمز المكافأة بنجاح، اذهب لاسترداده!",
            "fr": "Le code de récompense a été copié avec succès, allez l'échanger !",
            "de": "Der Geschenkcode wurde erfolgreich kopiert, jetzt loslegen und einlösen!",
            "id": "Kode Imbalan berhasil disalin, ayo tukarkan!",
            "ja": "報酬コードがコピーされました。今すぐ報酬を受け取りましょう！",
            "ko": "기프트 코드가 성공적으로 복사되었습니다. 가서 상품을 사용하세요!",
            "pt": "O Código de Recompensa foi copiado com sucesso, vá usar ele!",
            "ru": "Код награды скопирован; обменяйте его!",
            "es": "¡El código de recompensa se copió correctamente, ve a canjearlo!",
            "th": "คัดลอกรหัสรางวัลสำเร็จแล้ว ไปแลกรับเลย!",
            "tr": "Đã sao chép Mã Phần Thưởng thành công, mau đến và đổi mã nào!",
            "vi": "Il Codice premio è stato copiato con successo; vai a riscattarlo!",
            "it": "Ödül Kodu başarıyla kopyalandı, git ve kullan!",
            "zh-TW": "禮包碼已復製成功，快去兌換大獎！"
        },
        {
            "field1": "",
            "ID": "29",
            "Key": "账号登出",
            "zh-CN": "登出",
            "备注": "",
            "字节限制": "",
            "en": "Sign out",
            "ar": "تسجيل الخروج",
            "fr": "Se déconnecter",
            "de": "Abmelden",
            "id": "Keluar",
            "ja": "ログアウト",
            "ko": "로그아웃",
            "pt": "Desconectar",
            "ru": "Выйти",
            "es": "Cerrar sesión",
            "th": "ลงชื่ออก",
            "tr": "Đăng xuất",
            "vi": "Esci",
            "it": "Çıkış Yap",
            "zh-TW": "登出"
        },
        {
            "field1": "",
            "ID": "30",
            "Key": "账号登出提示",
            "zh-CN": "是否退出该登录的账号?",
            "备注": "",
            "字节限制": "",
            "en": "Are you sure to sign out of this account?",
            "ar": "هل أنت متأكد أنك تريد تسجيل الخروج من هذا الحساب؟",
            "fr": "Voulez-vous vraiment vous déconnecter de ce compte ?",
            "de": "Bist du sicher, dass du dich von diesem Konto abmelden willst?",
            "id": "Kamu yakin ingin keluar dari akun ini?",
            "ja": "このアカウントからログアウトしますか？",
            "ko": "로그인한 계정에서 로그아웃하시겠습니까?",
            "pt": "Tem certeza que deseja desconectar desta conta?",
            "ru": "Точно хотите выйти из этого аккаунта?",
            "es": "¿Seguro que quieres cerrar la sesión de esta cuenta?",
            "th": "คุณแน่ใจหรือไม่ว่าจะลงชื่อออกจากบัญชีนี้?",
            "tr": "Bạn có chắc muốn đăng xuất khỏi tài khoản này?",
            "vi": "Vuoi davvero uscire da questo account?",
            "it": "Bu hesaptan çıkış yapmak istediğine emin misin?",
            "zh-TW": "是否退出該登錄的賬號?"
        },
        {
            "field1": "",
            "ID": "31",
            "Key": "确认按钮",
            "zh-CN": "确定",
            "备注": "",
            "字节限制": "",
            "en": "OK",
            "ar": "موافق",
            "fr": "OK",
            "de": "OK",
            "id": "Oke",
            "ja": "はい",
            "ko": "확신하는",
            "pt": "OK",
            "ru": "OK",
            "es": "Aceptar",
            "th": "ตกลง",
            "tr": "OK",
            "vi": "OK",
            "it": "Tamam",
            "zh-TW": "確定"
        },
        {
            "field1": "",
            "ID": "32",
            "Key": "否认按钮",
            "zh-CN": "不，依旧使用该账号",
            "备注": "",
            "字节限制": "",
            "en": "No, still use this account",
            "ar": "لا، مواصلة استخدام هذا الحساب",
            "fr": "Non, continuer d'utiliser ce compte",
            "de": "Nein, dieses Konto weiterhin verwenden",
            "id": "Tidak, masih gunakan akun ini",
            "ja": "いいえ、このアカウントを使います",
            "ko": "아니요, 이 계정을 계속 사용합니다.",
            "pt": "Não, continuar usando esta conta",
            "ru": "Нет, продолжить использовать аккаунт",
            "es": "No seguir usando esta cuenta.",
            "th": "ไม่ ยังใช้บัญชีนี้อยู่",
            "tr": "Không, vẫn dùng tài khoản này",
            "vi": "No, usa ancora questo account",
            "it": "Hayır, bu hesabı kullanmaya devam et",
            "zh-TW": "不，依舊使用該賬號"
        },
        {
            "field1": "",
            "ID": "33",
            "Key": "",
            "zh-CN": "自创拼图也需要邀请别的好友哦",
            "备注": "",
            "字节限制": "",
            "en": "You have to invite a friend to complete your new puzzle too",
            "ar": "",
            "fr": "",
            "de": "",
            "id": "",
            "ja": "始まる前に友達を招待してね",
            "ko": "새 퍼즐을 완성하려면 다른 친구도 초대해야 합니다",
            "pt": "",
            "ru": "",
            "es": "",
            "th": "",
            "tr": "",
            "vi": "",
            "it": "",
            "zh-TW": "自創拼圖也需要邀請別的好友哦"
        },
        {
            "field1": "",
            "ID": "34",
            "Key": "",
            "zh-CN": "Archero3周年庆活动，创建你的拼图吧",
            "备注": "",
            "字节限制": "",
            "en": "Create your puzzle in the Archero 3rd Anniversary Event!",
            "ar": "",
            "fr": "",
            "de": "",
            "id": "",
            "ja": "Archero3周年記念、自分のパズルを作りましょう！",
            "ko": "궁수의 전설 3주년 이벤트에서 퍼즐을 만들어보세요!",
            "pt": "",
            "ru": "",
            "es": "",
            "th": "",
            "tr": "",
            "vi": "",
            "it": "",
            "zh-TW": "Archero3週年慶活動，創建你的拼圖吧"
        },
        {
            "field1": "",
            "ID": "35",
            "Key": "",
            "zh-CN": "创建拼图",
            "备注": "",
            "字节限制": "",
            "en": "Create Puzzle",
            "ar": "",
            "fr": "",
            "de": "",
            "id": "",
            "ja": "パズルを作る",
            "ko": "퍼즐 만들기",
            "pt": "",
            "ru": "",
            "es": "",
            "th": "",
            "tr": "",
            "vi": "",
            "it": "",
            "zh-TW": "創建拼圖"
        }
    ]



// WEBPACK FOOTER //
// ./src/tool/archeroLang.js